/* ==========================================================================
   fm-cart-count.js — la bulle du panier suit TOUTES les sources (For.me)
   --------------------------------------------------------------------------
   À CHARGER dans theme.liquid, sur toutes les pages :
     <script src="{{ 'fm-cart-count.js' | asset_url }}" defer></script>

   LE PROBLÈME
   -----------
   assets/cart-icon.js ne met la bulle à jour que sur un seul signal :

     document.addEventListener(StandardEvents.cartLinesUpdate, ...)

   C'est un événement interne au thème, émis par SES composants de panier.
   UpCart ne le connaît pas : il appelle /cart/add.js, /cart/change.js et
   /cart/update.js directement, en fetch. Le panier change donc réellement,
   mais le thème n'en est jamais informé, et la bulle garde l'ancien chiffre
   jusqu'au prochain rechargement complet de la page.

   CE QUE FAIT CE FICHIER
   ----------------------
   Il observe les appels réseau vers /cart/* et, dès qu'il en voit passer un,
   redemande /cart.js — la source de vérité — puis repose le compte.

   POURQUOI OBSERVER LE RÉSEAU PLUTÔT QU'ÉCOUTER UPCART
   Un événement propriétaire aurait lié ce correctif à une application précise
   et à une version précise de son API. Le réseau, lui, est la seule chose que
   TOUTE source de modification du panier a en commun : UpCart, le formulaire
   du thème, le mini-panier, une autre application demain. Un seul point
   d'écoute, aucune dépendance.

   ON N'INTERCEPTE RIEN, ON REGARDE PASSER
   Le fetch d'origine est appelé tel quel et sa promesse est renvoyée telle
   quelle. On y greffe une branche d'observation qui ne lit PAS le corps de la
   réponse — un corps ne se lit qu'une fois, et le consommer casserait
   l'appelant. On ne lit que l'URL.
   ========================================================================== */
(function () {
  'use strict';

  /* Les points d'entrée qui modifient le panier. /cart/add, /cart/change,
     /cart/update, /cart/clear — avec ou sans .js, avec ou sans préfixe de
     langue (/fr/cart/add.js). */
  var MOTIF = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function estMutationPanier(cible) {
    var url = '';
    try {
      if (typeof cible === 'string') url = cible;
      else if (cible && typeof cible.url === 'string') url = cible.url;   // objet Request
      else if (cible) url = String(cible);
    } catch (e) {
      return false;
    }
    return MOTIF.test(url);
  }

  /* ---------- pose du chiffre ---------- */

  function poser(n) {
    var icone = document.querySelector('cart-icon');

    /* Chemin privilégié : la méthode du composant du thème. Elle fait tout ce
       qu'il faut — le chiffre, les classes `hidden`/`visually-hidden`, la
       mémoire de session que lit ensuite ensureCartBubbleIsCorrect(), et
       l'animation. La réécrire ici aurait fatalement divergé. */
    if (icone && typeof icone.renderCartBubble === 'function') {
      icone.renderCartBubble(n);
      return;
    }

    /* Repli si le composant n'est pas (encore) défini : on écrit à la main.
       Mêmes classes que le thème, pour que son prochain passage retombe sur
       un état cohérent. */
    var compteur = document.querySelector('[ref="cartBubbleCount"]');
    var bulle = document.querySelector('[ref="cartBubble"]');
    if (!compteur) return;
    compteur.textContent = n < 100 ? String(n) : '';
    compteur.classList.toggle('hidden', n === 0);
    if (bulle) bulle.classList.toggle('visually-hidden', n === 0);
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(n < 100 ? n : ''), timestamp: Date.now() })
      );
    } catch (e) {
      /* navigation privée : on se passe de la mémoire de session */
    }
  }

  function compteActuel() {
    var compteur = document.querySelector('[ref="cartBubbleCount"]');
    if (!compteur) return null;
    var t = (compteur.textContent || '').trim();
    return t === '' ? null : parseInt(t, 10);
  }

  function relire() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart.js'
            : '/cart.js',
          { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier) return;
        var n = panier.item_count || 0;
        /* Ne pas rejouer l'animation pour rien si le chiffre n'a pas bougé. */
        if (compteActuel() === n) return;
        poser(n);
      })
      .catch(function () { /* hors ligne : on retentera au prochain appel */ });
  }

  /* DEUX PASSES. La première attrape le cas simple. La seconde existe parce
     qu'UpCart enchaîne parfois plusieurs appels (ajout puis recalcul des
     cadeaux / remises) : relire trop tôt donnerait un chiffre déjà périmé. */
  var minuteur = null;
  function planifier() {
    window.clearTimeout(minuteur);
    minuteur = window.setTimeout(function () {
      relire();
      window.setTimeout(relire, 700);
    }, 120);
  }

  /* ---------- observation du réseau ---------- */

  if (window.fetch) {
    var fetchOrigine = window.fetch;
    window.fetch = function (cible) {
      var promesse = fetchOrigine.apply(this, arguments);
      try {
        if (estMutationPanier(cible)) {
          /* Branche d'OBSERVATION : elle ne remplace pas la promesse rendue à
             l'appelant, elle s'y greffe. Le second argument absorbe un échec
             pour ne pas créer un rejet non géré de notre fait ; l'appelant
             garde le sien, intact. */
          promesse.then(planifier, function () {});
        }
      } catch (e) { /* jamais au détriment de l'appel d'origine */ }
      return promesse;
    };
  }

  /* Certaines applications passent encore par XMLHttpRequest. */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var openOrigine = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      try {
        if (estMutationPanier(url)) this.addEventListener('load', planifier);
      } catch (e) { /* idem */ }
      return openOrigine.apply(this, arguments);
    };
  }

  /* Retour par le bouton « précédent » : la page sort du cache avec un
     affichage figé, et le panier a pu changer entre-temps. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) relire();
  });

  /* Un onglet laissé ouvert pendant qu'on commande dans un autre. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) relire();
  });
})();
